import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  userRatingsModal: boolean;
};

const initialState: InitialState = {
  userRatingsModal: false,
};

const userRatingsModalSlice = createSlice({
  name: "userRatingsModalSlice",
  initialState,
  reducers: {
    toggleUserRatingsModal: (state, action: PayloadAction) => {
      state.userRatingsModal = !state.userRatingsModal;
      return state;
    },
  },
});

export const { toggleUserRatingsModal } = userRatingsModalSlice.actions;
export default userRatingsModalSlice;
